import axios from "axios";
const state = () => ({
  country_list: [],
  city_list: [],
  township_list: []
});

const getters = {
  getStateList: (state) => state.country_list,
  getCityList: (state) => state.city_list,
  getTownshipList: (state) => state.township_list
};

const mutations = {
  SET_COUNTRY_LIST(state, payload) {
    state.country_list = payload;
  },
  SET_CITY_LIST(state, payload) {
    state.city_list = payload;
  },
  SET_TOWNSHIP_LIST(state, payload) {
    state.township_list = payload;
  }
};

const actions = {
  async fetchCountryState({ commit }) {
    const odooUrl = process.env.VUE_APP_Odoo_URL;
    const res = await axios.get(`${odooUrl}v1/country-state`);
    commit("SET_COUNTRY_LIST", res.data);
  },
  async fetchCity({ commit }) {
    const odooUrl = process.env.VUE_APP_Odoo_URL;
    const res = await axios.get(`${odooUrl}v1/city`);
    commit("SET_CITY_LIST", res.data.data);
  },
  async fetchTownship({ commit }) {
    const odooUrl = process.env.VUE_APP_Odoo_URL;
    const res = await axios.get(`${odooUrl}v1/township`);
    commit("SET_TOWNSHIP_LIST", res.data.data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};


// const state = () => ({
//     country_list: [],
//     city_list: [],
//     township_list: []
// });
// const getters = {
//     getStateList(state) {
//         return state.country_list
//     },
//     getCityList(state) {
//         return state.city_list
//     },
//     getTownshipList(state) {
//         return state.township_list
//     }
// };
// const mutations = {
//     getCountryState(state) {
//         return new Promise((resolve, reject) => {
//             const odooUrl = process.env.VUE_APP_Odoo_URL
//             axios.get(`${odooUrl}v1/country-state`)
//             .then((response) => {
//                 state.country_list = response.data
//                 resolve(state.country_list)
//             }).catch(err => {
//                 reject(err)
//             })
//         })
//     },
//     async getCity(state) {
//         // Loading.show();
//         return new Promise((resolve, reject) => {
//             const odooUrl = process.env.VUE_APP_Odoo_URL
//             axios.get(`${odooUrl}v1/city`, {})
//             .then((response) => {
//                 state.city_list = response.data.data
//                 resolve(state.city_list)
//             })
//             .catch((error) => {
//                 reject(error)
//             });
//         })
//     },
//     async getTownship(state) {
//         // Loading.show();
//         return new Promise((resolve, reject) => {
//             const odooUrl = process.env.VUE_APP_Odoo_URL
//             axios.get(`${odooUrl}v1/township`, {})
//             .then((response) => {
//                 state.township_list = response.data.data
//                 resolve(state.township_list)
//             })
//             .catch((error) => {
//                 reject(error)
//             });
//         })
//     }
// }

// export default {
//     namespaced: true,
//     state,
//     getters,
//     mutations,
// };







